import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import Home from "./Pages/Home";
import ProductDetails from "./Pages/ProductDetails";
import { Toaster } from "react-hot-toast";
import About from "./Pages/About";
import Shop from "./Pages/Shop";
import Contact from "./Pages/Contact";
import Authentication from "./Pages/Authentication";
import TermsConditions from "./Pages/TermsConditions";
import ShoppingCart from "./Components/ShoppingCart/ShoppingCart";
import BannerForm from "./Pages/DashBoard/BannerForm";
import RegistrationForm from "./Components/Authentication/RegsiterForm/RegisterForm";
import PrivacyPolicyPage from "./Components/PrivacyPolicy/PrivacyPolicy";
import ReturnPolicyPage from "./Components/Returnpolicy/Returnpolicy";
import ShippingPolicyPage from "./Components/Shippingpolicy/Shippingpolicy";
import TermsAndConditionsPage from "./Components/Termsandconditions/UserTermsandCondition";
import OrderLoginPage from "./Components/Authentication/Orders/OrdersPage";
import SpecialGrid from "./Pages/Specials";
import NotFound from "./Pages/NotFound";
import Header from "../src/Components/Header/Navbar"
import { useDispatch, useSelector } from "react-redux";
import { GetBuyOrders } from "./Action/buy.Actions";
import { AppDispatch } from "./App/store";
import { loadFromStorage } from "./Slice/Auth.Slice";
import OrdersPage from "./Components/Authentication/Orders/OrdersPage";
import OrderTracking from "./Components/OrderTrack/OrderTracking";



const App: React.FC = () => {
const dispatch= useDispatch<AppDispatch>()

const {isAuthenticated,user}=useSelector((state:any)=> state.auth)

    useEffect(() => {
    const stored = localStorage.getItem('auth');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        dispatch(loadFromStorage(parsed)); // this sets isAuthenticated = true
      } catch (err) {
        console.error("Error loading user from localStorage", err);
        localStorage.removeItem('auth');
      }
    }
  }, [dispatch,isAuthenticated]);

  // ✅ Step 2: Once Redux has auth, fetch buy orders
  useEffect(() => {
    const stored = localStorage.getItem('auth');
    if (stored) {
      try {
        const values = JSON.parse(stored);
        if (values && values[0]?.mid && isAuthenticated) {
          dispatch(GetBuyOrders(values[0].mid));
        }
      } catch (error) {
        console.error('Error parsing auth in App.tsx', error);
      }
    }
  }, [isAuthenticated, dispatch]);




  return (
    <>
     
      <BrowserRouter>
        {/* <ScrollToTop /> */}
        <Header/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/product" element={<ProductDetails />} />
          <Route path="/loginSignUp" element={<Authentication />} />

          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/cart" element={< ShoppingCart />} />
          <Route path="/bannerForm" element={<BannerForm />} />
          {/* <Route path="/ProductForm" element={<ProductForms />} />
          <Route path="/LogoForm" element={<LogoForms />} /> */}
          {/* <Route path="/ProductTableForm" element={<ProductFormLists />} />
          <Route path="/bannerFormList" element={<BannerFormLists />} />
          <Route path="/LogoFormLists" element={<LogoFormLists />} /> */}
          <Route path="/RegisterForm" element={<RegistrationForm />} />
          <Route path="/special" element={<SpecialGrid />} />
          <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />
          <Route path="/returnpolicy" element={<ReturnPolicyPage />} />
          <Route path="/shippingpolicy" element={<ShippingPolicyPage />} />
          <Route path="/termsandcondition" element={<TermsAndConditionsPage />} />
          <Route path="/orders" element={<OrdersPage/>} />
          <Route path="/orderTracking" element={<OrderTracking/>}/>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </>
  );
};

export default App;
